import { createSliceForList } from "../helpers";

export const leftMenuSlice = createSliceForList({
  name: "leftMenu",
  initialState: {
    leftMenus: [],
    menuLoading: true,
  },
  reducers: {
    leftMenuFetched: (state, action) => {
      // 使用返回新对象的方式，避免 Immer 对 undefined 属性的 mutation 检测问题
      return {
        ...state,
        leftMenus: action.payload,
        menuLoading: false,
      };
    },
    catchError: (state, action) => {
      return {
        ...state,
        error: `${action.type}: ${action.payload.error}`,
        listLoading: false,
        menuLoading: false,
      };
    },
  },
});
